
import { Switch } from "@mui/material";
import axios from "axios";
import Select from "react-dropdown-select";
import Swal from "sweetalert2";
import TouchUpdateInputField from "../../component/TouchUpdateInputField";
import { GeographyDropdownValues, MajorColorArrays, MatchDropdownValues } from "../../constants";

const TrendingColorsTable = ({ imageData, mediaId, category, brands, getImageData, getBrands, type = 'social' }) => {


  const createNew = () => {
    axios.post(`/images-meta-api/trending-colors/new-row`, { category, mediaId, type }).then(response => {
      getImageData()
    })
  }
  const deleteData = (id) => {
    axios.post(`/images-meta-api/trending-colors/delete-data`, { category, mediaId, id, type }).then(response => {
      getImageData()
    })
  }
  const deleteImage = (imageUrl) => {
    axios.post(`/images-meta-api/trending-colors/delete-data`, { category, mediaId, type, image: true, id: imageUrl }).then(response => {
      getImageData()
    })
  }

  const updateData = (id, field, value) => {
    let requestBody;
    if (field == 'image') {
      requestBody = new FormData()
      requestBody.set('image', value)
      requestBody.set('category', category)
      requestBody.set('field', 'image')
      requestBody.set('type', type)
      requestBody.set('mediaId', mediaId)
      if (value && value.type && value.type && value.type.slice(0, 5) == 'video') {
        requestBody.set('isvideo', true)
      }
    } else {
      requestBody = { category, mediaId, id, field, value, type }
    }
    axios.post(`/images-meta-api/trending-colors/update-data`, requestBody).then(response => {
      if (field == 'brand' && value != null && !brands.includes(value))
        getBrands()
      getImageData()
    })
  }

  const uploadImage = () => {
    const imageInput = document.querySelector(`#image-upload`)
    if (!imageInput.files || imageInput.files.length == 0) {
      Swal.fire({ title: "No Image Selected", text: "Select an image to upload", timer: 1000 })
      return
    }
    const file = imageInput.files[0]
    updateData(null, 'image', file)
  }

  return <div>


    <div>

      <div className="flex justify-center w-full">
        {imageData && imageData.trendingColors && imageData.trendingColors[category] && imageData.trendingColors[category].images ? <><div className="flex justify-center  w-screen overflow-x-auto">
          {
            imageData.trendingColors[category].images.map((image, i) => <div key={i} className="mx-2 shrink-0">
              {!image.isVideo ? <img src={image.imageUrl} className="h-80" /> : <video src={image.imageUrl} className="h-80" controls />}
              <div className="p-2 flex justify-center items-center">
                <button className="primary-btn bg-red-600 hover:bg-red-700 active:bg-red-800 rounded-md"
                  onClick={(e => {
                    deleteImage(image.imageUrl)
                  })}>DELETE</button>
              </div>
            </div>)
          }
        </div>
        </> : null}
      </div>
      <div className="px-1 flex justify-center m-1">

        <input
          id={'image-upload'}
          type='file'
          accept="image/*, video/*"
        />
      </div>
      <div className="flex justify-center">
        <button className="primary-btn" onClick={() => {
          uploadImage()
        }}>UPLOAD</button>
      </div>
    </div>
    <table className="border-collapse min-w-full table-auto mt-4 border border-slate-600 mb-4 pb-4 overflow-x-auto">
      <thead>
        <tr>
          <th className="border border-slate-600 min-w-28">Select Color</th>
          <th className="border border-slate-600 min-w-28">DELETE</th>
        </tr>

      </thead>
      <tbody className="mb-2 pb-2">
        {
          imageData && imageData.trendingColors && imageData.trendingColors[category] && imageData.trendingColors[category].colors ?
            imageData.trendingColors[category].colors.map(tdata => <tr key={tdata.id} className='border-b w-full even:bg-slate-100'>
              <td className="border border-slate-600 p-1">
                <select className="border border-slate-300 rounded p-1 outline-none" value={tdata.color || ''}
                  onChange={(e) => {
                    updateData(tdata.id, 'color', e.target.value)
                  }}
                >
                  <option disabled value={''} >--select color--</option>
                  {Object.keys(MajorColorArrays).sort().map(c => <option key={c} value={c}>{c}</option>)}

                </select>
              </td>
              <td className="border border-slate-600 p-1">

                <button className="primary-btn bg-red-600 hover:bg-red-700 active:bg-red-800 rounded-md"
                  onClick={(e => {
                    deleteData(tdata.id)
                  })}
                >DELETE</button>
              </td>
            </tr>)


            : null
        }
        <tr className="w-full p-2">
          <td className="flex w-full pt-2" colSpan={2}><button onClick={createNew} className="w-40 px-4 py-2 mb-20 bg-slate-600 rounded text-white">Add More+</button></td>

        </tr>

      </tbody>

    </table >

  </div>
}

export default TrendingColorsTable;
